<template>
<div>
  <div @click="showFindings = !showFindings" class="checkpoint-intro">
    <columns class="is-mobile">
      <column>
        <h4 class="title is-5">{{ checkpoint.value }}</h4>
      </column>
      <column class="is-narrow">
        <span
          class="tag is-medium"
          :class="{
            'is-success': isCompliant,
            'is-danger': !isCompliant,
          }">
          {{ isCompliant ? 'Compliant' : 'Not Compliant' }}
        </span>
      </column>
    </columns>
  </div>

  <div class="mt-3" v-if="showFindings">
    <div 
      v-for="finding in findings" 
      :key="finding.id">
      <h5 class="title is-5 has-text-info is-marginless">{{ finding.finding.findable.type.title }}</h5>
      <div class="box">
        <attribute-finding-value  
          :value="$castTo(finding.finding.findable)" 
          :cast-type="finding.finding.findable.type.cast_type"
        />
      </div>
    </div>
  </div>
</div>  
</template>
<script>
export default {
  
  props: {
    checkpoint: {
      type: Object,
      default: () => ({})
    },
    findings: {
      type: Array,
      default: () => ([])
    }
  },

  data: () => ({
    showFindings: false
  }),

  computed: {
    isCompliant() {
      return this.findings.filter(finding => finding.is_compliant === false).length === 0
    },
  }

}
</script>